import React from 'react'
import { PropTypes } from 'prop-types'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const Image = props => {
  return (
    <div {...css(props.styles.component, props.styles.img)}>
      <div {...css(props.styles.pic)}>
        <div {...css(...props.component.values.map(c => props.styles[c]))} />
      </div>
      <div {...css(props.styles.text)}>
        {props.component.value.replace(/([^§]*)§([^§]*)§([^§]*)/g, '$1')}
        <b>{props.component.value.replace(/([^§]*)§([^§]*)§([^§]*)/g, '$2')}</b>
        {props.component.value.replace(/([^§]*)§([^§]*)§([^§]*)/g, '$3')}
      </div>
    </div>
  )
}

Image.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

export default withStyles(Styles)(Image)



// WEBPACK FOOTER //
// ./components/image/index.js